import _axios from '@/util/httpConfig.js'
import axios from 'axios'
// 以fileCode获取文件详情
export const getFileDetails = (appCode, tenantCode, data) => {
  // console.log(data);
  return _axios('POST', `/cloud-fastdfs/fastdfs/getFileInfoByFileCode/${tenantCode}/${appCode}`,'' , data)
}
// 下载fileCode
export function downloadFile(urls,modelName,type){
  let url = urls
  axios({
    method: "get",
    url:url,
    headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    },
    responseType: "blob"
  })
  .then(response => {
  let eleLink = document.createElement("a");
  if(type){
    eleLink.download = modelName+'.'+type;
  }else{
    eleLink.download = modelName;
  }
  eleLink.style.display = "none";
  let blob = new Blob([response.data]);
  eleLink.href = window.URL.createObjectURL(blob);
  document.body.appendChild(eleLink);
  eleLink.click();
  document.body.removeChild(eleLink);
  })
  .catch(error => {
  });
}


// WEBPACK FOOTER //
// ./src/api/file.js